
export let markers = {};

const Cross = "M1,0 L 4,0 M-1,0 L -4 0 M0 1 L 0 4 M0 -1 L 0 -4";
const DiamondEmpty = "M -4,0 L 0,4 L 4,0 L 0,-4 Z";
const DiamondFilled = "M -4,0 L 0,4 L 4,0 L 0,-4 Z M -3,0 L 0,3 L 3,0 L 0,-3 Z M -2,0 L 0,2 L 2,0 L 0,-2 Z M -1,0 L 0,1 L 1,0 L 0,-1 Z";
const SquareEmpty = "M -3,-3 L 3,-3 L 3,3 L -3,3 Z";
const SquareFilled = "M -3,-3 L 3,-3 L 3,3 L -3,3 Z M -2,-2 L 2,-2 L 2,2 L -2,2 Z M -1,-1 L 1,-1 L 1,1 L -1,1 Z";
const TriangleEmpty = "M -3.5,3.5 L 3.5,3.5 L 0,-3.5 Z";
const TriangleFilled = "M -3.5,3.5 L 3.5,3.5 L 0,-3.5 Z M -3,3 L 3,3 L 0,-3 Z M -3,3 L 3,3 L 0,-2 Z M -2,2 L 2,2 L 0,-2 Z M -1,1 L 1,1 L 0,-1 Z";
const BigDotEmpty = "M 0.0,3.5 A 3.5,3.5 0 1 0 -0.001,3.5 Z";
const BigDotFilled = "M 0.0,3.5 A 3.5,3.5 0 1 0 -0.001,3.5 Z M 0.0,2.5 A 2.5,2.5 0 1 0 -0.001,2.5 Z M 0.0,1.5 A 1.5,1.5 0 1 0 -0.001,1.5 Z M 0.0,0.5 A 0.5,0.5 0 1 0 -0.001,0.5 Z";
const AirCoupledRegularRight = "M-3,0 A3 3 0 0 1 3 0 A3 3 0 0 1 -3 0";
const AirCoupledNoResponseRight = "M-3,0 A3 3 0 0 1 3 0 A3 3 0 0 1 -3 0 M 0 3 L 0 13 M 0 13 L -5 7 M 0 13 L 5 7";
const AirCoupledUnmeasurableRight = "M-3,0 A3 3 0 0 1 3 0 A3 3 0 0 1 -3 0 M -2.5 -2.5 L -9 -9 M -9 -9 L -9 -3 M -9 -9 L -3 -9";
const AirCoupledMaskedRight = "M 0 -4.5 L 4 2.5 L -4 2.5 z";
const AirCoupledMaskedNoResponseRight = "M 0 -4.5 L 4 2.5 L -4 2.5 z M 0 3 L 0 13 M 0 13 L -5 7 M 0 13 L 5 7";
const AirCoupledMaskedUnmeasurableRight = "M 0 -4.5 L 4 2.5 L -4 2.5 z M -2.5 -2 L -9 -9 M -9 -9 L -9 -3 M -9 -9 L -3 -9";
const AirCoupledRegularLeft = "M -3.5 -3.5 L 3.5 3.5 M -3.5 3.5 L 3.5 -3.5";
const AirCoupledNoResponseLeft = "M -3.5 -3.5 L 3.5 3.5 M -3.5 3.5 L 3.5 -3.5 M 0 0 L 0 13 M 0 13 L -5 7 M 0 13 L 5 7";
const AirCoupledUnmeasurableLeft = "M -3.5 -3.5 L 3.5 3.5 M -3.5 3.5 L 3.5 -3.5 M 2.5 -2.5 L 9 -9 M 9 -9 L 9 -3 M 9 -9 L 3 -9";
const AirCoupledMaskedLeft = "M -3 -3 L -3 3 L 3 3 L 3 -3 z";
const AirCoupledMaskedNoResponseLeft = "M -3 -3 L -3 3 L 3 3 L 3 -3 z M 0 3 L 0 13 M 0 13 L -5 7 M 0 13 L 5 7";
const AirCoupledMaskedUnmeasurableLeft = "M -3 -3 L -3 3 L 3 3 L 3 -3 z M 2.5 -2.5 L 9 -9 L 9 -3 M 9 -9 L 3 -9";
const BoneCoupledRegularRight = "M 2 -5 L -3 0 M -3 0 L 2 5";
const BoneCoupledNoResponseRight = "M 2 -5 L -3 0 M -3 0 L 2 5 M -1 2 L -8 9 M -8 9 L -8 3 M -8 9 L -2 9";
const BoneCoupledUnmeasurableRight = "M 2 5 L -3 0 M -3 0 L 2 -5 M -1 -2 L -8 -9 M -8 -9 L -8 -3 M -8 -9 L -2 -9";
const BoneCoupledMaskedRight = "M -3 -4 L 3 -4 M -3 -4 L -3 4 M -3 4 L 3 4";
const BoneCoupledMaskedNoResponseRight = "M -3 -4 L 2 -4 M -3 -4 L -3 4 M -3 4 L 2 4  M -3 4 L -8 9 M -8 9 L -8 3 M -8 9 L -2 9";
const BoneCoupledMaskedUnmeasurableRight = "M -3 4 L 2 4 M -3 4 L -3 -4 M -3 -4 L 2 -4  M -3 -4 L -8 -9 M -8 -9 L -8 -3 M -8 -9 L -2 -9";
const BoneCoupledRegularLeft = "M -2 -5 L 3 0 M 3 0 L -2 5";
const BoneCoupledNoResponseLeft = "M -2 -5 L 3 0 M 3 0 L -2 5 M 1 2 L 8 9 M 8 9 L 8 3 M 8 9 L 2 9";
const BoneCoupledUnmeasurableLeft = "M -2 5 L 3 0 M 3 0 L -2 -5 M 1 -2 L 8 -9 M 8 -9 L 8 -3 M 8 -9 L 2 -9";
const BoneCoupledMaskedLeft = "M 3 -4 L -3 -4 M 3 -4 L 3 4 M 3 4 L -3 4";
const BoneCoupledMaskedNoResponseLeft = "M 3 -4 L -2 -4 M 3 -4 L 3 4 M 3 4 L -2 4  M 3 4 L 8 9 M 8 9 L 8 3 M 8 9 L 2 9";
const BoneCoupledMaskedUnmeasurableLeft = "M 3 4 L -2 4 M 3 4 L 3 -4 M 3 -4 L -2 -4  M 3 -4 L 8 -9 M 8 -9 L 8 -3 M 8 -9 L 2 -9";
const UclRegularRight = "M -4 -4 L 4 -4 M -4 -4 L -4 4 M 0 -4 L 0 2 M 4 -4 L 4 4";
const UclNoResponseRight = "M -4 -4 L 4 -4 M -4 -4 L -4 4 M 0 -4 L 0 2 M 4 -4 L 4 13 M -0.5 8 L 4 13 M 4 13 L 9 8";
const UclUnmeasurableRight = "M -4 -4 L 4 -4 M -4 -4 L -4 4 M 0 -4 L 0 2 M 4 -4 L 4 4 M -4 -4 L -9 -9 M -9 -9 L -9 -3 M -9 -9 L -3 -9";
const UclRegularLeft = "M -4 -4 L 4 -4 M -4 -4 L -4 4 M 0 -4 L 0 2 M 4 -4 L 4 4";
const UclNoResponseLeft = "M 4 -4 L -4 -4 M 4 -4 L 4 4 M 0 -4 L 0 2 M -4 -4 L -4 13 M 0.5 8 L -4 13 M -4 13 L -9 8";
const UclUnmeasurableLeft = "M 4 -4 L -4 -4 M 4 -4 L 4 4 M 0 -4 L 0 2 M -4 -4 L -4 4 M 4 -4 L 9 -9 L 9 -3 M 9 -9 L 3 -9";

export const ICON_PATH = {
    Cross,
    DiamondEmpty,
    DiamondFilled,
    SquareEmpty,
    SquareFilled,
    TriangleEmpty, TriangleFilled, BigDotEmpty, BigDotFilled,
    AirCoupledRegularRight, AirCoupledNoResponseRight, AirCoupledUnmeasurableRight, AirCoupledMaskedRight, AirCoupledMaskedNoResponseRight, AirCoupledMaskedUnmeasurableRight,
    AirCoupledRegularLeft, AirCoupledNoResponseLeft, AirCoupledUnmeasurableLeft, AirCoupledMaskedLeft, AirCoupledMaskedNoResponseLeft, AirCoupledMaskedUnmeasurableLeft,
    BoneCoupledRegularRight, BoneCoupledNoResponseRight, BoneCoupledUnmeasurableRight, BoneCoupledMaskedRight, BoneCoupledMaskedNoResponseRight, BoneCoupledMaskedUnmeasurableRight,
    BoneCoupledRegularLeft, BoneCoupledNoResponseLeft, BoneCoupledUnmeasurableLeft, BoneCoupledMaskedLeft, BoneCoupledMaskedNoResponseLeft, BoneCoupledMaskedUnmeasurableLeft,
    UclRegularRight, UclNoResponseRight, UclUnmeasurableRight, UclRegularLeft, UclNoResponseLeft, UclUnmeasurableLeft,
};

// iconsData.js
export const AC_ICONS_DATA_RIGHT = [
    { titleKey: "audiogram.airCoupledRegular", symbolKey: "AirCoupledRegularRight" },
    { titleKey: "audiogram.airCoupledNoResponse", symbolKey: "AirCoupledNoResponseRight" },
    { titleKey: "audiogram.airCoupledUnmeasurable", symbolKey: "AirCoupledUnmeasurableRight" },
    { titleKey: "audiogram.airCoupledMasked", symbolKey: "AirCoupledMaskedRight" },
    { titleKey: "audiogram.airCoupledMaskedNoResponse", symbolKey: "AirCoupledMaskedNoResponseRight" },
    { titleKey: "audiogram.airCoupledMaskedUnmeasurable", symbolKey: "AirCoupledMaskedUnmeasurableRight" },
    { titleKey: "audiogram.airCoupledAlwaysResponse", symbolKey: "AirCoupledRegularRight" },
    { titleKey: "audiogram.airCoupledMaskedAlwaysResponse", symbolKey: "AirCoupledMaskedRight" }
  ];
  
export const AC_ICONS_DATA_LEFT = [
    { titleKey: "audiogram.airCoupledRegular", symbolKey: "AirCoupledRegularLeft" },
    { titleKey: "audiogram.airCoupledNoResponse", symbolKey: "AirCoupledNoResponseLeft" },
    { titleKey: "audiogram.airCoupledUnmeasurable", symbolKey: "AirCoupledUnmeasurableLeft" },
    { titleKey: "audiogram.airCoupledMasked", symbolKey: "AirCoupledMaskedLeft" },
    { titleKey: "audiogram.airCoupledMaskedNoResponse", symbolKey: "AirCoupledMaskedNoResponseLeft" },
    { titleKey: "audiogram.airCoupledMaskedUnmeasurable", symbolKey: "AirCoupledMaskedUnmeasurableLeft" },
    { titleKey: "audiogram.airCoupledAlwaysResponse", symbolKey: "AirCoupledRegularLeft" },
    { titleKey: "audiogram.airCoupledMaskedAlwaysResponse", symbolKey: "AirCoupledMaskedLeft" }  
];

export const BC_ICONS_DATA_RIGHT = [
    { titleKey: "audiogram.boneCoupledRegular", symbolKey: "BoneCoupledRegularRight" },
    { titleKey: "audiogram.boneCoupledNoResponse", symbolKey: "BoneCoupledNoResponseRight" },
    { titleKey: "audiogram.boneCoupledUnmeasurable", symbolKey: "BoneCoupledUnmeasurableRight" },
    { titleKey: "audiogram.boneCoupledMasked", symbolKey: "BoneCoupledMaskedRight" },
    { titleKey: "audiogram.boneCoupledMaskedNoResponse", symbolKey: "BoneCoupledMaskedNoResponseRight" },
    { titleKey: "audiogram.boneCoupledMaskedUnmeasurable", symbolKey: "BoneCoupledMaskedUnmeasurableRight" },
    { titleKey: "audiogram.boneCoupledAlwaysResponse", symbolKey: "BoneCoupledRegularRight" },
    { titleKey: "audiogram.boneCoupledMaskedAlwaysResponse", symbolKey: "BoneCoupledMaskedRight" }
];
export const BC_ICONS_DATA_LEFT = [
    { titleKey: "audiogram.boneCoupledRegular", symbolKey: "BoneCoupledRegularLeft" },
    { titleKey: "audiogram.boneCoupledNoResponse", symbolKey: "BoneCoupledNoResponseLeft" },
    { titleKey: "audiogram.boneCoupledUnmeasurable", symbolKey: "BoneCoupledUnmeasurableLeft" },
    { titleKey: "audiogram.boneCoupledMasked", symbolKey: "BoneCoupledMaskedLeft" },
    { titleKey: "audiogram.boneCoupledMaskedNoResponse", symbolKey: "BoneCoupledMaskedNoResponseLeft" },
    { titleKey: "audiogram.boneCoupledMaskedUnmeasurable", symbolKey: "BoneCoupledMaskedUnmeasurableLeft" },
    { titleKey: "audiogram.boneCoupledAlwaysResponse", symbolKey: "BoneCoupledRegularLeft" },
    { titleKey: "audiogram.boneCoupledMaskedAlwaysResponse", symbolKey: "BoneCoupledMaskedLeft" }
];
      
export const UCL_ICONS_DATA_RIGHT = [
    { titleKey: "audiogram.uclRegular", icon: UclRegularRight, symbolKey: "UclRegularRight" },
    { titleKey: "audiogram.uclNoResponse", icon: UclNoResponseRight, symbolKey: "UclNoResponseRight" },
    { titleKey: "audiogram.uclUnmeasurable", icon: UclUnmeasurableRight, symbolKey: "UclUnmeasurableRight" },
    { titleKey: "audiogram.uclAlwaysResponse", icon: UclRegularRight, symbolKey: "UclRegularRight" }
];

export const UCL_ICONS_DATA_LEFT = [
    { titleKey: "audiogram.uclRegular", icon: UclRegularLeft, symbolKey: "UclRegularLeft" },
    { titleKey: "audiogram.uclNoResponse", icon: UclNoResponseLeft, symbolKey: "UclNoResponseLeft" },
    { titleKey: "audiogram.uclUnmeasurable", icon: UclUnmeasurableLeft, symbolKey: "UclUnmeasurableLeft" },
    { titleKey: "audiogram.uclAlwaysResponse", icon: UclRegularLeft, symbolKey: "UclRegularLeft" }
];
export const HALF_ICONFS = [
    "UclRegularLeft", "UclRegularRight", "BoneCoupledRegularLeft", "BoneCoupledRegularRight", "AirCoupledRegularRight", "AirCoupledRegularLeft", "circle"
];

export const SYMBOLS_Info = {
    AirCoupledNoResponseRight: {
        offset: [0, 5],
    },
    AirCoupledNoResponseLeft: {
        offset: [0, 5],
    },
    AirCoupledUnmeasurableRight: {
        offset: [0, -1],
    },
    AirCoupledUnmeasurableLeft: {
        offset: [3, -6],
    },
    AirCoupledMaskedNoResponseRight: {
        offset: [0, 5],
        size: 22,
    },
    AirCoupledMaskedNoResponseLeft: {
        offset: [0, 4],
    },
    AirCoupledMaskedUnmeasurableLeft: {
        offset: [3, -3],
    },
    UclNoResponseRight: {
        offset: [0, 6],
    },
    UclNoResponseLeft: {
        offset: [0, 6],
    },
};